// tslint:disable:no-null-keyword
import { FormArray, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CustomValidators } from '../../../validators/custom-validators';
import { SelectControlConfigOption } from '../select-control-config-option.model';
import { SelectControl } from '../select-control.model';

export class SelectControlConfigHelper {

    static getConfigFormControls(
        control: SelectControl = new SelectControl()
    ): {[id: string]: FormControl | FormArray} {

        const options = control.config.options || [];
        return {
            multi: new FormControl(control.config.multi),
            options: new FormArray(options
                .map(option =>
                    SelectControlConfigHelper.getOptionFormGroup(option)
                )
            )
        };
    }

    static getOptionFormGroup(option: SelectControlConfigOption): FormGroup {
        return new FormGroup({
            value: new FormControl(
                option.value,
                [Validators.maxLength(20), Validators.required]
            ),
            title: new FormControl(
                option.title,
                [Validators.maxLength(20), Validators.required]
            ),
            score: new FormControl(
                option.score,
                [CustomValidators.integer, Validators.min(0)]
            )
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/select/config/select-control-config.helper.ts